import { catalogProducts } from "@/data/accessoryQuoteCatalog";

export type ParsedModelReference = { input: string; matchedModel?: string; matchedBrand?: string };
export const BULK_MODEL_REFERENCE_LIMIT = 40;
export const BULK_MODEL_INPUT_LIMIT = 1600;
export const QUOTE_DETAILS_SAFE_LIMIT = 4400;

export function parseBulkModelReferences(value: string): ParsedModelReference[] {
  const references = value
    .split(/[\n,;]+/)
    .map((item) => item.trim())
    .filter(Boolean)
    .slice(0, BULK_MODEL_REFERENCE_LIMIT);

  return references.map((input) => {
    const normalized = input.toLowerCase().replace(/[^a-z0-9]/g, "");
    const match = catalogProducts.find((product) => {
      const model = product.model.toLowerCase().replace(/[^a-z0-9]/g, "");
      return model === normalized || model.includes(normalized) || normalized.includes(model);
    });
    return match ? { input, matchedModel: match.model, matchedBrand: match.brand } : { input };
  });
}

export function appendBulkModelReferences(message: string, references: ParsedModelReference[]) {
  if (!references.length) return message;
  const lines = references.map((reference) => reference.matchedModel ? `• ${reference.matchedBrand} ${reference.matchedModel}` : `• ${reference.input} (confirm model reference)`).join("\n");
  const section = `Bulk model / SKU references (quote-preparation list; confirm configuration):\n${lines}`;
  return [message.trim(), section].filter(Boolean).join("\n\n");
}

export function getBulkModelReferenceValidationError(message: string, value: string) {
  if (value.length > BULK_MODEL_INPUT_LIMIT) return `Keep the model/SKU list to ${BULK_MODEL_INPUT_LIMIT.toLocaleString()} characters or less.`;
  const rawReferences = value.split(/[\n,;]+/).map((item) => item.trim()).filter(Boolean);
  if (rawReferences.length > BULK_MODEL_REFERENCE_LIMIT) return `Send up to ${BULK_MODEL_REFERENCE_LIMIT} model references per quote request.`;
  const combinedDetails = appendBulkModelReferences(message, parseBulkModelReferences(value));
  if (combinedDetails.length > QUOTE_DETAILS_SAFE_LIMIT) return "Shorten the project details or model/SKU list so both can be sent safely in one quote request.";
  return null;
}
